import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'https://savedelete.com';

const api = axios.create({
  baseURL: `${BASE_URL}/api/creator`,
  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export interface WalletInfo {
  points_balance: number;
  lifetime_points: number;
  month_points: number;
  referral_code: string;
  referral_link: string;
  paypal_email: string;
  is_suspended: boolean;
}

export interface LedgerEntry {
  action: string; points: number; note: string; created_at: string;
}

export interface LeaderboardRow { username: string; display_name: string; points: number; }

export interface RewardsRates {
  points: Record<string, number>;
  caps: Record<string, number>;
  cash_mode: boolean;
}

export const ACTION_LABELS: Record<string, string> = {
  post_created: 'Post published',
  like_received: 'Like received',
  comment_received: 'Comment received',
  follower_gained: 'New follower',
  share_visit: 'Share visit',
  referral_signup: 'Referral signed up',
  referral_qualified: 'Referral qualified',
  quality_bonus: 'Quality bonus',
  clawback: 'Adjustment',
  adjustment: 'Adjustment',
};

export const REF_KEY = 'sd:ref';

export const captureRef = () => {
  try {
    const ref = new URLSearchParams(window.location.search).get('ref');
    if (ref) localStorage.setItem(REF_KEY, JSON.stringify({ code: ref, ts: Date.now() }));
  } catch { /* ignore */ }
};

export const storedRefCode = (): string | null => {
  try {
    const raw = localStorage.getItem(REF_KEY);
    if (!raw) return null;
    const { code, ts } = JSON.parse(raw);
    if (Date.now() - ts > 30 * 24 * 3600 * 1000) return null;
    return code || null;
  } catch { return null; }
};

export const creatorApi = {
  getWallet: async (): Promise<WalletInfo> => (await api.get('/me/wallet/')).data,
  setPaypalEmail: async (email: string): Promise<WalletInfo> =>
    (await api.patch('/me/wallet/', { paypal_email: email })).data,
  getLedger: async (page = 1) => (await api.get('/me/ledger/', { params: { page } })).data,
  getReferrals: async () => (await api.get('/me/referrals/')).data.referrals,
  getLeaderboard: async (): Promise<{ month: string; leaders: LeaderboardRow[] }> =>
    (await api.get('/leaderboard/')).data,
  getRates: async (): Promise<RewardsRates> => (await api.get('/config/')).data,
  reportShareVisit: (postSlug: string, ref: string) =>
    api.post('/share-visit/', { post_slug: postSlug, ref }).catch(() => {}),
};
